<div class="mb-3">
  <mwp-translation />
</div>
<div class="mfa-container">
  @switch (mode) {
    @case (authenticatorMode.Onboarding) {
      <div class="message-instructions mb-3">
        <mwp-text-translate text="For security purposes, you need to setup a secondary authentication method.  Once setup, you will be sent a numeric code you will need to enter, in addition to your user name and password, in order to enter the system.  Please choose your preferred secondary authentication method from the options below:" jsonKey="mfaOnboarding" />
      </div>
      <form [formGroup]="onBoardingForm" autocomplete="off">
        <div class="row">
          <div class="col-12">
            <mwp-radio-button [form]="onBoardingForm" [displayInline]="false" nameForControl="verificationType" [data]="authenticatorTypes" keyText="text" keyValue="value" [autoTranslate]="false" />
            @if (isMember) {
              <div class="mt-2 w-10">
                <mwp-input [form]="onBoardingForm" labelName="Phone Number" nameForControl="phoneNumber" [maskType]="maskType.phone" />
              </div>
            }
          </div>
        </div>
      </form>
      <div class="d-flex justify-content-center w-100 mb-3">
        <button class="mwp-button mt-3 w-100" [disabled]="onBoardingForm.invalid" (click)="onbaordingProcess()">
          <mwp-text-translate text="Continue" jsonKey="continue" />
        </button>
      </div>
      <div class="d-flex justify-content-center w-100">
        <button class="mwp-button-secondary w-100" (click)="cancelLogin()">
          <mwp-text-translate text="Cancel" jsonKey="cancel" />
        </button>
      </div>
    }

    @case (authenticatorMode.Selection) {
      <div class="message-instructions mb-3">
        @if (isEmailOnly) {
          <div class="d-inline-flex flex-wrap">
            <mwp-text-translate text="Click below to send a code." jsonKey="mfaSelectionEmailOnly1" />
            <div class="mx-1">
              {{multiFactorAuthenticator.email}}
            </div>
            <mwp-text-translate text="to verify your log in." jsonKey="mfaSelectionEmailOnly2" />
          </div>
        } @else {
          <mwp-text-translate text="Choose an authentication method below to log in" jsonKey="mfaSelection" />
        }
      </div>
      @if (!isEmailOnly) {
        <form [formGroup]="selectionModeForm" autocomplete="off" class="mb-3">
          <div class="row">
            <div class="col-12">
              <mwp-radio-button [form]="selectionModeForm" [displayInline]="false" nameForControl="verificationType" [data]="authenticatorTypes" keyText="text" keyValue="value" [autoTranslate]="false" />
            </div>
          </div>
        </form>
      }
      <div class="d-flex justify-content-center w-100 mb-3">
        <button class="mwp-button w-100" [disabled]="selectionModeForm.invalid && !isEmailOnly" (click)="setSelection()">
          @if (isEmailOnly) {
            <mwp-text-translate text="Send Code" jsonKey="sendCode" />
          }  @else {
            <mwp-text-translate text="Continue" jsonKey="continue" />
          }
        </button>
      </div>
      <div class="d-flex justify-content-center w-100">
        <button class="mwp-button-secondary w-100" (click)="cancelLogin()">
          <mwp-text-translate text="Cancel" jsonKey="cancel" />
        </button>
      </div>
    }

    @case (authenticatorMode.Configuration){
      @if (configPhoneNumber) {
        <div class="message-instructions mb-3">
          @if (selectedAuthenticatorType == authenticatorType.S) {
            <mwp-text-translate text="Enter a cell phone number below to receive an authentication code." jsonKey="mfaPhone" />
          } @else {
            <mwp-text-translate text="Enter a phone number below to receive an authentication code." jsonKey="mfaPhone" />
          }
        </div>
        <form [formGroup]="configForm" autocomplete="off" class="mb-3">
          <mwp-input [form]="configForm" labelName="Phone Number" nameForControl="phoneNumber" [maskType]="maskType.phone" />
        </form>
        <div class="d-flex justify-content-center w-100 mb-3">
          <button class="mwp-button w-100" [disabled]="configForm.invalid" (click)="setPhoneAndSendCode()">
            <mwp-text-translate text="Continue" jsonKey="continue" />
          </button>
        </div>
        <div class="d-flex justify-content-center w-100">
          <button class="mwp-button-secondary w-100" (click)="resetConfiugration()">
            <mwp-text-translate text="Return" jsonKey="return" />
          </button>
        </div>
      }
      @if (configQR) {
        <div class="message-instructions mb-3">`
          <mwp-text-translate text="Scan the QR Code below using your preferred authenticator app." jsonKey="mfaQRCode" />
        </div>
        <div class="d-flex justify-content-center mb-3">
          <img [src]="selectedAuthenticatorQR.qrCodeUrl" style="width: 180px; height: 180px; image-rendering: pixelated;" />
        </div>
        <div class="message-instructions mb-3">
          <mwp-text-translate text="If you are unable to scan the code into your authenticator app, copy the code below instead." jsonKey="mfaQRManualEntryCode" />
        </div>
        <div class="mb-3">
          <div class="text-center fw-bold px-3">
            {{selectedAuthenticatorQR.manualEntryKey}}
          </div>
          <div class="d-flex justify-content-center">
            <div class="d-inline-flex selectable-div" [cdkCopyToClipboard]="selectedAuthenticatorQR.manualEntryKey">
              <mwp-text-translate text="Copy" jsonKey="copy" />
              <mwp-svg-icon [SvgMatType]="svgType.Copy" [SvgColor]="svgColor.stdIcon" />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center w-100 mb-3">
          <button class="mwp-button w-100" (click)="setQRAndSendCode()">
            <mwp-text-translate text="Continue" jsonKey="continue" />
          </button>
        </div>
        <div class="d-flex justify-content-center w-100">
          <button class="mwp-button-secondary w-100" (click)="resetConfiugration()">
            <mwp-text-translate text="Return" jsonKey="return" />
          </button>
        </div>
      }
    }

    @case (authenticatorMode.Verification) {
      <form [formGroup]="verifyForm" autocomplete="off">
        <div class="fw-bold d-flex justify-content-center">
          <div class="message-instructions mb-3">
            @if (verifyMessageKey) {
              <mwp-text-translate [text]="verifyMessage" [jsonKey]="verifyMessageKey" />
            }
            <mwp-text-translate text="Please input the code provided to log in." jsonKey="mfaVerify" />
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <mwp-verify-code [form]="verifyForm" nameForRadioControl="verifyCode" [useFixedWidth]="true" />
        </div>
      </form>
      <div class="d-flex justify-content-center">
        <button class="mwp-button mt-3 w-100" [disabled]="verifyForm.invalid" (click)="verifyCode()">
          <mwp-text-translate text="Verify Code" jsonKey="verifyCode" />
        </button>
      </div>
      @if (this.selectedAuthenticatorType.toString() != 'Q') {
        <div class="d-flex justify-content-center">
          <button class="mwp-button-secondary w-100 mt-3" (click)="resendCode()" [disabled]="!buttonEnabled">
            {{getResendButtonText()}}
          </button>
        </div>
      }
      @if (buttonVerifyByEmailEnabled) {
        <div class="d-flex justify-content-center">
          <button class="mwp-button-secondary w-100 mt-3" (click)="sendCodeByEmail()">
            <mwp-text-translate text="Send Code To Your Email" jsonKey="SendCodeToYourEmail" />
          </button>
        </div>
      }
    }
  }
</div>